// import React from 'react';
// import { Swiper, SwiperSlide } from 'swiper/react';
// import { Navigation, Pagination, Autoplay } from 'swiper/modules';
// import importImage from "../../utils/images/importImage";
// // Import Swiper styles
// import 'swiper/css';
// import 'swiper/css/navigation';
// import 'swiper/css/pagination';
// import { useLanguage } from '../../contexts/LanguageContext';

// const FirstImage = importImage("4.jpg");
// const SecondImage = importImage("4.jpg");
// const ThirdImage = importImage("4.jpg");

// const ImageSlider = () => {
//   const { t } = useLanguage();
//   const slides = [
//     {
//       id: 1,
//       bgImage: FirstImage,
//       welcome: t('placeholders.password', 'Enter your password'),
//       title: t('slider.slide1.title', 'Enter your password'),
//       description: t('slider.slide1.des', 'Enter your password'),
//       cta: "Shop Now"
//     },
//     {
//       id: 2,
//       bgImage: SecondImage,
//       welcome: "New Arrivals",
//       title: t('slider.slide2.title', 'Enter your password'),
//       description: t('slider.slide2.des', 'Enter your password'),
//       cta: "Explore Colors"
//     },
//     { 
//       id: 3,
//       bgImage: ThirdImage,
//       welcome: "Sustainable Choice",
//       title: t('slider.slide3.title', 'Enter your password'),
//       description: t('slider.slide3.des', 'Enter your password'),
//       cta: "Learn More"
//     }
//   ];

//   return (
//     <section className='image-slider-sec'>
//       <div className="slider-container" style={{ maxWidth: '100%', margin: '0 auto' }}>
//         <Swiper
//           spaceBetween={0}
//           slidesPerView={1}
//           loop={true}
//           navigation
//           pagination={{ clickable: true }}
//           autoplay={{
//             delay: 5000,
//             disableOnInteraction: false
//           }}
//           modules={[Navigation, Pagination, Autoplay]}
//         >
//           {slides.map((slide) => (
//             <SwiperSlide key={slide.id}>
//               <div 
//                 className="slide-background"
//                 style={{
//                   backgroundImage: `url(${slide.bgImage})`,
//                   backgroundSize: 'cover',
//                   backgroundPosition: 'center',
//                   height: '600px',
//                   position: 'relative',
//                   borderRadius: '8px'
//                 }}
//               >
//                 <div className="overlay" style={{
//                   position: 'absolute',
//                   top: 0,
//                   left: 0,
//                   right: 0,
//                   bottom: 0,
//                   backgroundColor: 'rgba(0,0,0,0.4)',
//                   borderRadius: '8px'
//                 }}>
//                   <div className='container h-100'>
//                     <div className='row align-items-center h-100'>
//                       <div className='col-lg-6 py-4'>
//                         <div className="p-3">
//                           {/*<h5 className="text-white text-uppercase mb-3 animated slideInDown">{slide.welcome}</h5>*/}
//                           <h1 className="display-4 text-white mb-md-4 animated zoomIn">{slide.title}</h1>
//                           <p className="text-white mb-4 fs-5">{slide.description}</p>
//                           {/*<button className="btn btn-primary btn-lg px-4 py-2">
//                           </button>*/}
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </SwiperSlide>
//           ))}
//         </Swiper>
//       </div>
//     </section>
//   );
// };

// export default ImageSlider;

// import React from 'react';
// import { Swiper, SwiperSlide } from 'swiper/react';
// import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper/modules';
// import importImage from "../../utils/images/importImage";
// import 'swiper/css';
// import 'swiper/css/navigation';
// import 'swiper/css/pagination';
// import 'swiper/css/effect-fade';
// import { useLanguage } from '../../contexts/LanguageContext';
// import './ImageSlider.css';

// const FirstImage = importImage("4.jpg");
// const SecondImage = importImage("4.jpg");
// const ThirdImage = importImage("4.jpg");

// const ImageSlider = () => {
//   const { t } = useLanguage();
//   const slides = [
//     {
//       id: 1,
//       bgImage: FirstImage,
//       title: t('slider.slide1.title', 'Stylish & Modern'),
//       description: t('slider.slide1.des', 'Experience our latest collection with elegance and style.'),
//       cta: "Shop Now"
//     },
//     {
//       id: 2,
//       bgImage: SecondImage,
//       title: t('slider.slide2.title', 'New Arrivals'),
//       description: t('slider.slide2.des', 'Discover fresh products handpicked for you.'),
//       cta: "Explore Colors"
//     },
//     { 
//       id: 3,
//       bgImage: ThirdImage,
//       title: t('slider.slide3.title', 'Sustainable Choice'),
//       description: t('slider.slide3.des', 'Eco-friendly and stylish options for your lifestyle.'),
//       cta: "Learn More"
//     }
//   ];

//   return (
//     <section className='image-slider-sec'>
//       <Swiper
//         spaceBetween={0}
//         slidesPerView={1}
//         loop={true}
//         navigation
//         pagination={{ clickable: true }}
//         autoplay={{ delay: 4000, disableOnInteraction: false }}
//         effect="fade"
//         modules={[Navigation, Pagination, Autoplay, EffectFade]}
//       >
//         {slides.map(slide => (
//           <SwiperSlide key={slide.id}>
//             <div className="slide-background" style={{ backgroundImage: `url(${slide.bgImage})` }}>
//               <div className="slide-overlay">
//                 <div className="slide-content container h-100 d-flex align-items-center">
//                   <div className="col-lg-6">
//                     <h1 className="slide-title">{slide.title}</h1>
//                     <p className="slide-desc">{slide.description}</p>
//                     <button className="slide-btn">{slide.cta}</button>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </SwiperSlide>
//         ))}
//       </Swiper>
//     </section>
//   );
// };

// export default ImageSlider;


import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper/modules';
import importImage from "../../utils/images/importImage";
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import { useLanguage } from '../../contexts/LanguageContext';
import './ImageSlider.css';

const FirstImage = importImage("Banner-IMG.png");
const SecondImage = importImage("Banner-IMG.png");
const ThirdImage = importImage("Banner-IMG.png");

const forImg = importImage("Header-bg.png")

const ImageSlider = () => {
  const { t } = useLanguage();
  const slides = [
    {
      id: 1,
      bgImage: FirstImage,
      title: t('slider.slide1.title', 'Stylish & Modern'),
      description: t('slider.slide1.des', 'Experience our latest collection with elegance and style.')
    },
    {
      id: 2,
      bgImage: SecondImage,
      title: t('slider.slide2.title', 'New Arrivals'),
      description: t('slider.slide2.des', 'Discover fresh products handpicked for you.')
    },
    { 
      id: 3,
      bgImage: ThirdImage,
      title: t('slider.slide3.title', 'Sustainable Choice'),
      description: t('slider.slide3.des', 'Eco-friendly and stylish options for your lifestyle.')
    }
  ];

  return (
    <section className='image-slider-sec'>
      <Swiper
        spaceBetween={0}
        slidesPerView={1}
        loop={true}
        // navigation
        pagination={{ clickable: true }}
        autoplay={{ delay: 4000, disableOnInteraction: false }}
        effect="fade"
        modules={[Navigation, Pagination, Autoplay, EffectFade]}
      >
        {slides.map(slide => (
          // <SwiperSlide key={slide.id}>
          //   <div className="slide-background" style={{ backgroundImage: `url(${slide.bgImage})` }}>
          //     <div className="slide-overlay">
          //       <div className="floating-shapes">
          //         <span className="shape circle"></span>
          //         <span className="shape small-circle"></span>
          //         <span className="shape triangle"></span>
          //         <span className="shape square"></span>
          //       </div>

          //       <div className="slide-content container h-100 d-flex align-items-center">
          //         <div className="col-lg-6">
          //           <h1 className="slide-title">{slide.title}</h1>
          //           <p className="slide-desc">{slide.description}</p>
          //         </div>
          //       </div>
          //     </div>
          //   </div>
          // </SwiperSlide>
          <SwiperSlide key={slide.id}>
  <div
    className="slide-background"
    style={{ backgroundImage: `url(${slide.bgImage})` }}
  >
    {/* ⭐ FRONT IMAGE */}
    <img src={forImg} alt="foreground" className="front-image" />

    <div className="slide-overlay">
      {/* Floating shapes */}
      <div className="floating-shapes">
        <span className="shape circle"></span>
        <span className="shape small-circle"></span>
        <span className="shape triangle"></span>
        <span className="shape square"></span>
      </div>

      <div className="slide-content container h-100 d-flex align-items-center">
        <div className="col-lg-6">
          <h1 className="slide-title">{slide.title}</h1>
          <p className="slide-desc">{slide.description}</p>
        </div>
      </div>
    </div>
  </div>
</SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default ImageSlider;
